import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {SerializableInventoryItem} from "../api";

export class SerializableInventoryService extends RestService<SerializableInventoryItem> {
    constructor(url: string) {
        url ? super(url) : super(REST_API_END_POINTS.SERIALIZABLE_INVENTORY)
    }

    get_part_number_by_description(description: string) {
        return this.instance.get(
            `${this.url}part_number_by_description/${description}/`
        )
    }

    hide_part_number(description: string, part_number: string) {
        return this.instance.post(
            `${this.url}hide_part_number/`, {
                description: description,
                part_number: part_number
            }
        )
    }
}
